"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisingStore = void 0;
var mobx_1 = require("mobx");
var bernie_logger_1 = require("bernie-logger");
var bernie_plugin_mobx_1 = require("bernie-plugin-mobx");
var SUPPRESS_ADS_FRAMEWORK = 'FRAMEWORK';
var AdvertisingStore = /** @class */ (function (_super) {
    __extends(AdvertisingStore, _super);
    function AdvertisingStore(state, logger) {
        if (state === void 0) { state = {}; }
        if (logger === void 0) { logger = bernie_logger_1.NOOP_LOGGER; }
        return _super.call(this, state, logger) || this;
    }
    AdvertisingStore.prototype.hydrate = function (data) {
        Object.assign(this, data);
    };
    AdvertisingStore.prototype.trigger = function (pageName) {
        this.triggeredPageName = pageName;
    };
    AdvertisingStore.prototype.suppressAds = function (scope) {
        var uppercaseScope = scope.toUpperCase();
        if (uppercaseScope === SUPPRESS_ADS_FRAMEWORK) {
            this.disableFramework = true;
            this.includeAdLoader = false;
        }
    };
    AdvertisingStore.prototype.overrideTargeting = function (targetingKey) {
        this.CMPTST = targetingKey;
    };
    AdvertisingStore.prototype.overrideSlotId = function (slotId) {
        this.adSlotIdOverride = slotId;
    };
    AdvertisingStore.prototype.overridePageId = function (pageId) {
        this.adPageIdOverride = pageId;
    };
    AdvertisingStore.prototype.includeAd = function () {
        if (!this.disableFramework) {
            this.includeAdLoader = true;
        }
    };
    /**
     * @param queryParams: array of query params in the request URL
     * adTargetingOverride=: used to override ad targeting parameter CMPST
     * adSlotIdOverride=: used to override ad slot indentifier. useful to force specific ad content without modifying
     *     the Flex template. This override is global though, all ad placements on the page will be overridden to
     *     this by this param
     * suppressAds=framework -> Do not load the meso ad loader script or any individual ad placements
     */
    AdvertisingStore.prototype.overrideWithQueryParams = function (queryParams) {
        if (queryParams.suppressAds) {
            this.suppressAds(queryParams.suppressAds);
        }
        if (queryParams.adTargetingOverride) {
            this.overrideTargeting(queryParams.adTargetingOverride);
        }
        if (queryParams.adSlotIdOverride) {
            this.overrideSlotId(queryParams.adSlotIdOverride);
        }
    };
    AdvertisingStore.DEFAULTS = {
        CMPTST: "",
        adSlotIdOverride: "",
        disableFramework: false,
        includeAdLoader: false,
        triggeredPageName: undefined,
        env: undefined
    };
    __decorate([
        mobx_1.observable
    ], AdvertisingStore.prototype, "includeAdLoader", void 0);
    __decorate([
        mobx_1.observable
    ], AdvertisingStore.prototype, "CMPTST", void 0);
    __decorate([
        mobx_1.observable
    ], AdvertisingStore.prototype, "adSlotIdOverride", void 0);
    __decorate([
        mobx_1.observable
    ], AdvertisingStore.prototype, "adPageIdOverride", void 0);
    __decorate([
        mobx_1.observable
    ], AdvertisingStore.prototype, "adBlockerEnabled", void 0);
    __decorate([
        mobx_1.observable
    ], AdvertisingStore.prototype, "triggeredPageName", void 0);
    __decorate([
        mobx_1.observable
    ], AdvertisingStore.prototype, "canTrack", void 0);
    __decorate([
        mobx_1.action
    ], AdvertisingStore.prototype, "trigger", null);
    __decorate([
        mobx_1.action
    ], AdvertisingStore.prototype, "suppressAds", null);
    __decorate([
        mobx_1.action
    ], AdvertisingStore.prototype, "overrideTargeting", null);
    __decorate([
        mobx_1.action
    ], AdvertisingStore.prototype, "overrideSlotId", null);
    __decorate([
        mobx_1.action
    ], AdvertisingStore.prototype, "overridePageId", null);
    __decorate([
        mobx_1.action
    ], AdvertisingStore.prototype, "includeAd", null);
    __decorate([
        mobx_1.action
    ], AdvertisingStore.prototype, "overrideWithQueryParams", null);
    return AdvertisingStore;
}(bernie_plugin_mobx_1.Store));
exports.AdvertisingStore = AdvertisingStore;
//# sourceMappingURL=advertising-store.js.map